import { render } from "./TicketMailThread.vue?vue&type=template&id=24eac0ca&scoped=true"
import script from "./TicketMailThread.vue?vue&type=script&lang=js"
export * from "./TicketMailThread.vue?vue&type=script&lang=js"

import "./TicketMailThread.vue?vue&type=style&index=0&id=24eac0ca&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eac0ca"]])

export default __exports__